import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { Utilities, DataRowState } from "@tylertech/shared-module";
import { IdValuePair, MailingAddressViewModel } from "@tylertech/tyler-api-types";

import { MailingAddressService } from "../../services";

@Component({
    selector: "mailing-address-card",
    templateUrl: "./mailingAddressCard.tmpl.html",
    standalone: false
})
export class MailingAddressCardComponent implements OnInit
{
    private $mailingAddressService = inject(MailingAddressService);

    readonly cardForm: FormGroup;

    @Input() readonly usages: ReadonlyArray<IdValuePair>;
    @Input("mailingAddresses") readonly originalMailingAddresses: ReadonlyArray<MailingAddressViewModel>;
    @Input() private readonly parentId: string;
    @Input() readonly parentType: string;
    @Input() readonly viewOnly: boolean;
    @Input() readonly isContactNew: boolean;
    @Output() private readonly close = new EventEmitter<Array<MailingAddressViewModel> | undefined>();

    mailingAddresses: Array<MailingAddressViewModel>;

    constructor()
    {
        this.cardForm = new FormGroup({});
    }

    get invalid(): boolean { return this.cardForm.invalid; }

    ngOnInit(): void
    {
        this.mailingAddresses = Utilities.deepCopy(this.originalMailingAddresses as Array<MailingAddressViewModel>);
        if (!this.mailingAddresses.length)
        {
            this.createNewMailingAddress(true);
        }
    }

    addClicked(): void
    {
        this.createNewMailingAddress();
    }

    private createNewMailingAddress(primary?: boolean): void
    {
        const newItem: MailingAddressViewModel = {
            Id: Utilities.generateRandomGuid(),
            ContactId: this.parentId,
            RowState: DataRowState.Added,
            IsPrimary: primary,
            Attention: undefined,
            Line1: undefined,
            Line2: undefined,
            City: undefined,
            State: undefined,
            PostalCode: undefined,
            Country: undefined,
            CertificationResults: undefined,
            FullMailingAddress: undefined,
            IsCertified: undefined,
            IsForwarding: undefined,
        };
        this.mailingAddresses.push(newItem);
    }

    cancelClicked(): void
    {
        this.close.emit();
    }

    doneClicked(): void
    {
        if (this.cardForm.invalid)
        {
            return;
        }

        // Don't update mailing addresses as the contact hasn't been created yet. This will happen on save.
        if (this.isContactNew)
        {
            this.close.emit(this.mailingAddresses);
            return;
        }

        this.$mailingAddressService.confirmAndSaveChanges(this.mailingAddresses)
            .then((mailingAddresses: Array<MailingAddressViewModel>) =>
            {
                this.close.emit(mailingAddresses);
            });
    }
}
